// src/pages/About.js
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { scroller } from 'react-scroll';
import './About.css';
import ComprehensiveSection from "../components/ComprehensiveSection";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import aboutSolutionsData from '../components/aboutSolutionsData';
import Solutions from "../components/Solutions";
import CallToAction from '../components/CallToAction';
import PageImage from "../assets/about-hero.jpg";
import logo1 from '../assets/emr.png';
import logo2 from '../assets/digital-footprint.png';
import logo3 from '../assets/digital-outreach.png';
import logo4 from '../assets/billing-and-payments.png';
import logo5 from '../assets/data-and-insights.png';



const About = () => {

  const location = useLocation();

  // Scroll to Solutions section if state indicates so
  useEffect(() => {
    if (location.state?.scrollToSolutions) {
      scroller.scrollTo('solutions', {
        smooth: true,
        duration: 1000,
        offset: -70, // Adjust as per the header height
      });
    }
  }, [location.state]);


  //passing data dynamically to comprehensive section
  const blockData = [
    {
      logo: logo1,
      title: 'EMR',
      text: 'Experience a certified EHR solution offering robust charting, documentation, patient histories, eRx, eLabs, telehealth, and customizable care delivery.',
      link: '/emr',
    },
    {
      logo: logo2,
      title: 'Digital Footprint',
      text: 'Expand your practice with secure websites, expert SEO, search marketing tools, reputation management, web profiles, and social media management.',
      link: '/digital-footprint',
    },
    {
      logo: logo3,
      title: 'Digital Outreach',
      text: 'Expand your reach through search marketing tools, automated reputation management, polished web profiles, and effective social media management.',
      link: '/digital-outreach',
    },
    {
      logo: logo4,
      title: 'Billing & Payments',
      text: 'Enroll, submit, and track on a unified platform. Gain financial visibility with reporting, analytics, automation, and streamlined payment methods for faster collections.',
      link: '/billing-and-payments',
    },
    {
      logo: logo5,
      title: 'Data & Insights',
      text: 'Get deeper insights of your practice growth, patient revenue with Doclivo analytics. Unlock valuable data and insights to drive informed decisions and improve performance.',
      link: '/data-and-insights',
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Company Overview - Doclivo</title>
        <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
        <meta name="keywords" content="about us, company, automation" />
      </Helmet>

      <Navbar></Navbar>
    
      <section id="about" className="about-section">
        <div className="about-header">
          <h5 className="about-sub-heading">Why Doclivo</h5>
          <h1 className="about-main-heading">
            The premier practice automation platform, enhancing patient experience, provider well-being, and overall practice efficiency.
          </h1>
          <p className="platform-details">
            Doclivo is a comprehensive platform designed to meet the needs of healthcare providers ranging from independent doctors to multi-specialty hospitals. It offers an intuitive technology stack that streamlines operations by eliminating the need for managing multiple applications or dealing with interfaces of varying capabilities across different platforms. With Doclivo, independent healthcare practices gain access to an EMR solution equipped with digital tools and support to thrive in the evolving healthcare landscape. This all-in-one practice growth platform simplifies every aspect of the patient journey, making it easier for healthcare professionals to focus on delivering quality care while efficiently managing their practices.
          </p>
          <img src={PageImage} alt="horizontal doctor-img" className="header-page"></img>
          {/* <img
            src={PageImage}
            alt="horizontal doctor-img"
            className="w-full h-auto object-cover block"
          /> */}
        </div>
        {/* Render the Solutions component with the about page data */}
        <Solutions
          solutionsData={aboutSolutionsData}
          sectionSubtitle="Solutions"
          showButton={false} // Hide the button
        />
      </section>

      <ComprehensiveSection blockData={blockData} />
      {/* <Testimonials></Testimonials> */}
      <CallToAction></CallToAction>
      <Footer></Footer>
    </div>
  );
};

export default About;
